import { useController } from 'react-hook-form';
import { Add16, Close16 } from 'ui/icons';
import { InputText } from 'ui/inputs';
import { BUTTON_SIZES, BUTTON_VARIANTS, GhostSuccessButton, IconButton } from 'ui/button';
import { CustomTextFieldsList, InputTextRow } from './styles';

const CONTENT = { textFieldsAddButtonLabel: 'Add field' };

export const CustomTextFields = () => {
  const {
    field: { onChange: setFields, value: fields },
  } = useController({
    name: 'textFields',
  });

  const handleAddTextField = () => {
    const updatedTextFields = [...fields];
    updatedTextFields.push('');
    setFields(updatedTextFields);
  };

  const handleUpdateTextField = (value: string, index: number) => {
    const updatedTextFields = [...fields];
    updatedTextFields[index] = value;
    setFields(updatedTextFields);
  };

  const handleDeleteTextField = (index: number) => {
    const updatedTextFields = [...fields];
    updatedTextFields.splice(index, 1);
    setFields(updatedTextFields);
  };

  return (
    <CustomTextFieldsList data-test="custom-text-fields">
      {fields.map((field: string, index: number) => (
        <InputTextRow key={`custom-text-field-input-${index}`}>
          <InputText onChange={(value) => handleUpdateTextField(value, index)} value={field} />
          <IconButton
            data-test="custom-text-field-input-delete-button"
            onClick={() => handleDeleteTextField(index)}
            size={BUTTON_SIZES.LARGE}
            variant={BUTTON_VARIANTS.GHOST}
          >
            <Close16 />
          </IconButton>
        </InputTextRow>
      ))}
      <GhostSuccessButton
        data-test="custom-text-field-add-button"
        isDisabled={fields.length === 50}
        onClick={handleAddTextField}
      >
        <Add16 />
        <span>{CONTENT.textFieldsAddButtonLabel}</span>
      </GhostSuccessButton>
    </CustomTextFieldsList>
  );
};
